import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.territories.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.territories.actionsLoading;
export const getItems = (state:RootState) => state.territories.items;
export const getItemsSelect = (state:RootState) => state.territories.dropDownItems;
export const getItemsCount = (state:RootState) => state.territories.itemsCount;
export const getItemForEdit = (state:RootState) => state.territories.itemForEdit;
export const getError = (state:RootState) => state.territories.error;
export const getErrorAction = (state:RootState) => state.territories.errorAction;
export const validationErrors = (state: RootState) => state.territories.validationErrors;
